module.exports = __webpack_public_path__ + "banquet/components/AccountSettings/images/email_toggle_highlight.aea4130114b4a20c8dfc81f430ce9a79.png";


//////////////////
// WEBPACK FOOTER
// ./banquet/components/AccountSettings/images/email_toggle_highlight.png
// module id = 1641
// module chunks = 1